<template>
  <div id="app">
    <Layout />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import logger from '@/utils/logger';
import globals from '@/globals';
import './app.css';
import Layout from '@/components/layout/Layout.vue';

export default defineComponent({
  components: {
    Layout,
  },
  created() {
    const txt = '### YOU ARE IN DEVELOPMENT MODE ###';
    const final = `%c${txt}`;
    const consoleMsgStyle = `
    padding: 5px;
    color: #ffffff;
    font-weight: bold;
    border-radius: 5%;
    background: #555555;`;
    logger.log(final, consoleMsgStyle);

    // EXPORT TO WINDOW --- REMEMBER: THIS IS DEV ENV
    Object.assign(globals.context, {
      app: this,
    });
  },
});
</script>

<style scoped lang='scss'>
#app {
  &:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1001;
    pointer-events: none;
    box-shadow: inset 0 0 0.3em 0.1em #00b8ff;
  }
}
</style>
